import { z } from 'zod'

export const paramsSchema = z.object({
  firstName: z.string(),
  lastName: z.string().nullable(),
  emailAddress: z.string(),
  emailAddressRepeat: z.string(),
  facebookId: z.string().nullable(),
  googleId: z.string().nullable(),
  appleId: z.string().nullable(),
  recaptcha: z.string(),
  signUpOrigin: z.string(),
  provinceId: z.number().int().nullable(),
  source: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
